import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { defaultContainerSize, mq } from '../../../styles/mixins';

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.core_white};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mq.medium(css`
    padding-left: 3rem;
    padding-right: 3rem;
  `)};

  ${mq.large(css`
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  `)};

  ${mq.xLarge(css`
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  `)};
`;

export const Title = styled.h1`
  font-family: var(--font-base);
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 3.5rem;
  letter-spacing: -0.013rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 4rem 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    margin: 5rem 0 3rem 0;
  `)};

  ${mq.xLarge(css`
    margin-top: 7.5rem;
  `)};
`;

export const Approaches = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Approach = styled.div`
  width: 100%;
  margin-bottom: 5.5rem;

  ${mq.medium(css`
    width: 19.75rem;
    margin-right: 1.85rem;
  `)};

  ${mq.xLarge(css`
    width: 23rem;
  `)};
`;

export const ApproachText = styled.div`
  position: relative;
  font-family: var(--font-base);
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 1.75rem;
  letter-spacing: -0.013rem;
  color: ${({ theme }) => theme.colors.core_black};
  padding-bottom: 0.625rem;
  margin-bottom: 0.625rem;

  &:after {
    background: linear-gradient(89.99deg, #0e4ed7 -15.08%, #f94743 93.47%);
    transition: opacity 200ms ease-in-out;
    content: '';
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

export const ApproachDescription = styled.div`
  font-family: var(--font-second);
  font-size: 1rem;
  font-style: normal;
  font-weight: 300;
  line-height: 2rem;
  letter-spacing: 0.013rem;
  text-align: left;
  color: ${({ theme }) => theme.colors.darker_grey};
`;
